export default __webpack_public_path__ + "static/media/ge2.8ad7bbe9.jpg";